import { request } from './base';

export type Brands = {
  [index: string]: string;
}

export const getBrands = (): Promise<Brands> =>
  request('/brands')
    .then(res => res.json())
    .then(({ data }) => data);